/**
 * Created by Administrator on 2019/5/17.
 */
import Vue from "vue";
export const EventBus = new Vue();
